"use client";
import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { HiMenuAlt3 } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const close = ()=> {
    setIsOpen(false)
  }

  return (
    <div className="bg-[#142528] px-4 py-4 md:py-6 md:px-10 lg:px-10 xl:px-32 lg:py-4 ">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img
            src={"/assets/vantlogo.svg"}
            className="h-[28px] md:h-[34px] lg:h-[40px]"
            alt="vant_logo"
          />
        </Link>
        <ul className="hidden md:flex items-center justify-between gap-4 xl:gap-12 font-inter cursor-pointer">
          <Link to="/" >
            <li className="text-white text-sm hover:text-[#32AE4C]">Home</li>
          </Link>
          <Link to="/personal">
            <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
              <li className="text-sm">Personal</li>
            </div>
          </Link>
          {/* <Link to="/business">
            <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
              <li className="text-sm">Business</li>
            </div>
          </Link> */}
          <Link
            to="https://vantpapi.readme.io/reference/getting-started-with-your-api"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
              <li className="text-sm">Developers</li>
              {/* <IoIosArrowDown /> */}
            </div>
          </Link>
          {/* <Link to="/">

          <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
            <li className="text-sm">Resources</li>
          </div>
          </Link> */}
          <Link to="/company">
            <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
              <li className="text-sm">Company</li>
              {/* <IoIosArrowDown /> */}
            </div>
          </Link>
            <Link to="/blog">
            <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
              <li className="text-sm">Blogs</li>
              {/* <IoIosArrowDown /> */}
            </div>
          </Link>
        </ul>
        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="https://business.vant.ng/login"
            rel="noreferrer"
            target="_blank"
          >
            <button className="font-inter border-none outline-none text-white text-sm hover:text-[#32AE4C]">
              Sign In
            </button>
          </Link>
          <Link
            to="https://business.vant.ng/signup"
            rel="noreferrer"
            target="_blank"
          >
            <button className="font-inter bg-[#32AE4C] text-white px-2 py-1 md:py-2 md:px-4 rounded-full text-sm hover:bg-white hover:text-[#142528]">
              Sign Up for free
            </button>
          </Link>
        </div>

        <button onClick={() => setIsOpen(!isOpen)} className="block md:hidden">
          {!isOpen ? (
            <HiMenuAlt3 className="text-white h-6 w-6 md:h-12 md:w-12" />
          ) : (
            <IoMdClose className="text-white h-6 w-6 md:h- md:w-12" />
          )}
        </button>
      </div>
      {isOpen && (
        <div className="p-5">
          <ul className="flex flex-col items-center justify-between gap-4 font-inter">
           
                       <Link to="/" onClick={close}>

            <li className="text-white text-text-sm md:text-2xl hover:text-[#32AE4C]">
              Home
            </li>
            </Link>
            <Link to="/personal" onClick={close}>
              <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
                <li className="text-sm md:text-2xl">Personal</li>
                {/* <IoIosArrowDown className='h-4 w-4 md:h-8 md:w-8'/> */}
              </div>
            </Link>
            {/* <Link to="/business" onClick={close}>
              <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
                <li className="text-sm md:text-2xl">Business</li>
              </div>
            </Link> */}
            <Link
              to="https://vantpapi.readme.io/reference/getting-started-with-your-api"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
                <li className="text-sm md:text-2xl">Developers</li>
                {/* <IoIosArrowDown className='h-4 w-4 md:h-8 md:w-8'/> */}
              </div>
            </Link>
            <Link to="/company" onClick={close}>
              <div className="text-white flex items-center gap-1 hover:text-[#32AE4C]">
                <li className="text-sm md:text-2xl">Company</li>
                {/* <IoIosArrowDown className='h-4 w-4 md:h-8 md:w-8'/> */}
              </div>
            </Link>
            <Link
              to="https://business.vant.ng/login"
              rel="noreferrer"
              target="_blank"
            >
              <button className="font-inter border text-white  px-8 py-2 md:py-2 md:px-20 rounded-full text-xs md:text-2xl ">
                Sign In
              </button>
            </Link>

            <Link
              to="https://business.vant.ng/signup"
              rel="noreferrer"
              target="_blank"
            >
              <button className="font-inter bg-[#32AE4C] text-white px-2 py-2 md:py-2 md:px-8 rounded-full text-xs md:text-2xl hover:bg-white hover:text-[#142528]">
                Sign Up for free
              </button>
            </Link>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Navbar;
